/* eslint-disable @typescript-eslint/no-explicit-any */
import { logger } from '@marriott/mi-headless-utils';
import { DataLayerAttributes } from './index.types';
import { getDataLayer } from './index';

export const getDatalayerResponse = async (req: any) => {
  global.loggerInstance = logger({
    sessionID: req?.cookies?.sessionID,
    requestID: req.headers['x-request-id'],
  }) as CallableFunction;
  const { log } = global.loggerInstance('getDatalayerResponse');
  const requestId = req.headers['x-request-id'];
  const currentLocale = req.headers['accept-language'];
  const locale = currentLocale?.split(',')[0]?.replace('-', '_');
  log.debug(`getDataLayer request headers Accept-Language: ${req.headers['accept-language']}`);
  log.debug(
    `getDataLayer request headers requestId: ${req.headers['x-request-id']} and host: ${req.headers['x-host']}`
  );
  log.debug(`getDataLayer resolvedUrl passed ${requestId?.split('.mi')[0]}`);
  log.debug(`getDataLayer locale passed ${locale}`);
  const datalayerResp = await getDataLayer(req, requestId?.split('.mi')[0], locale);

  const dataLayer = JSON.stringify(datalayerResp?.data[0] || {});
  const mvpOffers =
    datalayerResp?.mvpOffersData && datalayerResp?.mvpOffersData !== 'null' ? datalayerResp?.mvpOffersData : '{}';

  return { dataLayer, mvpOffers };
};

export function normalizeDataAttributes(attributes?: DataLayerAttributes[]) {
  return attributes?.reduce((acc: Record<string, string>, attr: DataLayerAttributes) => {
    if (attr.value && attr.value !== 'undefined' && attr.value !== null) {
      acc[attr.key as string] = attr.value as string;
    }
    return acc;
  }, {});
}

export const updateDatalayer = (name: string, value: string) => {
  const dataLayer = (window.dataLayer = window.dataLayer || ({} as any));
  dataLayer[name] = value;
};
